// extracted by mini-css-extract-plugin
export default {"isPaying":"Ty4fu","button":"mhIbI","error":"lQpkX","cardLabel":"yicd9","cardDetails":"HL4eT","emailInput":"Sbs0q","emailSuggestion":"fybNK"};